export class MergeModel {
  firstName?: string;
  Id?: string;
  phoneNumber?: string;
  primaryIDdesc?: string;
  primaryId?: string;
  dob?: any;
  gender?: string;
  mrn?: string;
  primaryMrn?: string;
  secondaryMrn?: string;
  primaryPatientDetails?: string;
  secondaryPatientDetails?:string;
  mergedBy?: string;
  performedBy?:string;
  mergedOn?: any;
  mergedReason?:string;
  mergedRemarks?:string;
  unMergedBy?: string;
  unMergedOn?: any;
  reason?:string;
  remarks?:string;
  performedOn?:any;
  unMergedReason?:string;
  unMergedRemarks?:string;
  status?: string;
  countryCode?:string;
  primaryGender?:string;
  firstAge?:string;
  primaryDob?:any;
  seondaryGender?:string;
  secondName?:string;
  secondaryDob?:any;
  secondAge?:string;

}
